module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M46.56.349L28.8 9.251V3.2c0-1.12-.576-2.144-1.507-2.72-.957-.576-2.144-.64-3.133-.131L6.4 9.251V1.6A1.6 1.6 0 0 0 4.8 0H1.6A1.6 1.6 0 0 0 0 1.6v28.8A1.6 1.6 0 0 0 1.6 32h3.2a1.6 1.6 0 0 0 1.6-1.6v-7.616l17.76 8.864c.445.224.96.352 1.44.352a3.192 3.192 0 0 0 3.2-3.2v-6.016l17.76 8.864c.448.224.96.352 1.44.352.576 0 1.184-.16 1.696-.48A3.196 3.196 0 0 0 51.2 28.8V3.2c0-1.12-.576-2.144-1.504-2.72-.96-.573-2.144-.64-3.136-.131z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/previous-2.js
// module id = 1355
// module chunks = 14